Vue.asyncComponent('cms-login-form', {
    data() {
        return {
            loading: false,
            steps: ['email', 'password'],
            ssoFailed: false,
            errorMessage: null,
            step: 'email',
            sso: null,
            values: {
                email: null,
                password: null,
                authenticationCode: null,
            }
        }
    },
    methods: {
        async nextStep() {
            if (this.loading) {
                return;
            }

            let valid = await this.validate(this.step);
            if (! valid) {
                return;
            }

            let indexOfCurrentStep = this.steps.indexOf(this.step);
            this.step = this.steps[indexOfCurrentStep + 1];
        },
        focusField() {
            this.$nextTick(() => {
                this.$el.querySelector('#' + this.step)?.focus();
            });
        },
        goToStep(step) {
            this.step = step;
        },
        async validate(step) {
            this.errorMessage = null;
            this.loading = true;

            let result = await this.$post(
                this.$getSetting('paths.baseAuth') + '/user/validate-' + step,
                this.values
            );

            this.loading = false;
            if (result.ssoRedirectUrl) {
                window.location.assign(result.ssoRedirectUrl);
                return false;
            }

            if (result.authenticated) {
                this.authenticated(result);
                return result.success;
            }

            if (! result.success) {
                this.errorMessage = result.errorMessage;
                return result.success;
            }

            if (result.requireAuthenticationCode) {
                this.steps.push('tfa');
                return result.success;
            }

            return result.success;
        },
        authenticated(data) {
            this.$authService.setUser({name: data.user.name});
            this.loading = true;
            this.$actionHandler.handle(data.todos, this);
        },
        passwordRecovery() {
            this.$router.push({name: 'password-recovery'});
        }
    },
    mounted() {
        setTimeout(this.focusField, 200);
    },
    created() {
        this.sso = this.$getSetting('sso');
        this.ssoFailed = (new URLSearchParams(window.location.search)).get('ssoFailed');
    }
}, 'cms/form/cms-login-form.html');
